import axios from 'axios';
import axiosInstance from '../axiosInstance';

export const fetchTickets = async (page, view, location) => {
  try {
    const response = await axiosInstance.get(
      `ticket/list?page=${page}&view=${view}&limit=20&locId=${location}`,
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const fetchFilterTickets = async (
  page,
  selectedFilters,
  selectedCompanies,
  selectedDepartments,
  selectedCategories,
  selectedSubCategories,
  selectedTicketTypes,
  selectedStatus,
  selectedRating,
  fromDate,
  toDate,
  selectedLocation
) => {
  try {
    const response = await axiosInstance.post(
      "ticket/filterlist",
      {
        view: selectedFilters,
        companyName: selectedCompanies,
        defaultGroup: selectedDepartments,
        category: selectedCategories,
        subCategory: selectedSubCategories,
        ticketType: selectedTicketTypes,
        status: selectedStatus,
        rating: selectedRating,
        from: fromDate,
        to: toDate,
        locationName: selectedLocation
      },
      {
        params: {
          limit: 20,
          page: page
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};


export const fetchCompanies = async () => {
  try {
    const response = await axiosInstance.get(`ticket/companyname`, {
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const fetchCompaniesData = async (selectedLocation) => {
  try {
    const response = await axiosInstance.get(`ticket/companyname?location=${selectedLocation}`, {
    });
    return response;
  } catch (error) {
    throw error;
  }
};


export const fetchCategoriesAndSubCategories = async () => {
  try {
    const response = await axiosInstance.get(`subcategory/categorylist`, {
    });
    return response;
  } catch (error) {
    throw error;
  }
};
  


export const fetchCategoriesAndSubCategoriesList = async (groupType) => {
  try {
    const response = await axiosInstance.get(`subcategory/categorylist?groupType=${groupType}`, {
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const fetchWorkFlow = async () => {
  try {
    const response = await axiosInstance.get(`workflow/list`, {
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const fetchTag = async () => {
  try {
    const response = await axiosInstance.get(`common/categorytaglist`, {
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateCriticalStatus = async (ticketId, isCritical) => {
  try {
    const requestBody = {
      isCritical: isCritical,
      ticketId: ticketId,
    };

    const response = await axiosInstance.put("ticket/critical", requestBody, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// export const submitTicketStatus = async (
//   ticketId,
//   status,
//   actionTaken = null,
//   file,
//   resolutionFile,
//   resolution = null,
//   reopenedMessage = null,
//   reopenFile,
//   prvImgFileDone,
//   infoMsg = null,
//   infoFile,
//   statusUpdate = null,
//   messageFile
// ) => {
//   // Initialize request data object
//   const requestData = {
//     status,
//     ticketId
//   };

//   // Add optional fields if they exist
//   if (actionTaken) {
//     requestData.actionTaken = actionTaken;
//   }

//   if (reopenedMessage) {
//     requestData.reopenedMessage = reopenedMessage;
//   }

//   if (resolution) {
//     requestData.resolution = resolution;
//   }

//   if (infoMsg) {
//     requestData.reqInfoMessage = infoMsg;
//   }

//   if (statusUpdate) {
//     requestData.statusUpdate = statusUpdate;
//   }


//   // Handle action files
//   if (file.length > 0) {
//     const actionFileKeys = await Promise.all(file.map(async (file) => {
//       const attachments = {
//         bucket: `${process.env.REACT_APP_BUCKET_NAME}`,
//         key: `attachment/${Date.now()}-${file.name}`,
//       };

//       try {
//         const response = await axiosInstance.post(
//           `${process.env.REACT_APP_API_FILE_UPLOAD}fileupload`,
//           attachments
//         );

//         await axios.put(response.data.uploadUrl, file, {
//           headers: {
//             'Content-Type': file.type,
//           }
//         });

//         return response.data.key;
//       } catch (error) {
//         console.error("Error uploading action file:", error);
//         return null;
//       }
//     }));
//     requestData.actionFile = actionFileKeys.filter(key => key !== null);
//   }

//   // Handle resolution files
//   if (resolutionFile.length > 0) {
//     const resolutionFileKeys = await Promise.all(resolutionFile.map(async (file) => {
//       const attachments = {
//         bucket: `${process.env.REACT_APP_BUCKET_NAME}`,
//         key: `attachment/${Date.now()}-${file.name}`,
//       };

//       try {
//         const response = await axiosInstance.post(
//           `${process.env.REACT_APP_API_FILE_UPLOAD}fileupload`,
//           attachments
//         );

//         await axios.put(response.data.uploadUrl, file, {
//           headers: {
//             'Content-Type': file.type,
//           }
//         });

//         return response.data.key;
//       } catch (error) {
//         console.error("Error uploading resolution file:", error);
//         return null;
//       }
//     }));
//     requestData.resolutionFile = resolutionFileKeys.filter(key => key !== null);
//   }

//   // Handle reopen files
//   if (reopenFile.length > 0) {
//     const reopenFileKeys = await Promise.all(reopenFile.map(async (file) => {
//       const attachments = {
//         bucket: `${process.env.REACT_APP_BUCKET_NAME}`,
//         key: `attachment/${Date.now()}-${file.name}`,
//       };

//       try {
//         const response = await axiosInstance.post(
//           `${process.env.REACT_APP_API_FILE_UPLOAD}fileupload`,
//           attachments
//         );

//         await axios.put(response.data.uploadUrl, file, {
//           headers: {
//             'Content-Type': file.type,
//           }
//         });

//         return response.data.key;
//       } catch (error) {
//         console.error("Error uploading reopen file:", error);
//         return null;
//       }
//     }));
//     requestData.reopenFile = reopenFileKeys.filter(key => key !== null);
//   }

//   if (prvImgFileDone.length > 0) {
//     // Extract just the attachment ID part from the full URL
//     const cleanedAttachments = prvImgFileDone.map(url => {
//       // Find the text "attachment/" and the ID that follows
//       const match = url.match(/(attachment\/[^\/]+)/);
//       return match ? match[1] : url;
//     });
//     requestData.prevAttachment = cleanedAttachments;
//   }

//   if (infoFile.length > 0) {
//     const infoFileKeys = await Promise.all(infoFile.map(async (file) => {
//       const attachments = {
//         bucket: `${process.env.REACT_APP_BUCKET_NAME}`,
//         key: `attachment/${Date.now()}-${file.name}`,
//       };

//       try {
//         const response = await axiosInstance.post(
//           `${process.env.REACT_APP_API_FILE_UPLOAD}fileupload`,
//           attachments
//         );

//         await axios.put(response.data.uploadUrl, file, {
//           headers: {
//             'Content-Type': file.type,
//           }
//         });

//         return response.data.key;
//       } catch (error) {
//         console.error("Error uploading resolution file:", error);
//         return null;
//       }
//     }));
//     requestData.reqInfoFile = infoFileKeys.filter(key => key !== null);
//   }
// // ... existing code ...


// if (messageFile.length > 0) {
//   const infoFileKeys = await Promise.all(messageFile.map(async (file) => {
//     const attachments = {
//       bucket: `${process.env.REACT_APP_BUCKET_NAME}`,
//       key: `attachment/${Date.now()}-${file.name}`,
//     };

//     try {
//       const response = await axiosInstance.post(
//         `${process.env.REACT_APP_API_FILE_UPLOAD}fileupload`,
//         attachments
//       );

//       await axios.put(response.data.uploadUrl, file, {
//         headers: {
//           'Content-Type': file.type,
//         }
//       });

//       return response.data.key;
//     } catch (error) {
//       console.error("Error uploading resolution file:", error);
//       return null;
//     }
//   }));
//   requestData.messageFile = infoFileKeys.filter(key => key !== null);
// }

//   try {
//     const response = await axiosInstance.put("ticket/status", requestData, {
//       headers: {
//         "Content-Type": "application/json",
//       },
//     });

//     return response.data;
//   } catch (error) {
//     console.error("Error updating ticket status:", error);
//     throw error;
//   }
// };


export const submitTicketStatus = async (ticketId, status, values, prevAttachment) => {
  const requestData = {
    status,
    ticketId,
  };
  console.log(prevAttachment,"prevAttachmentprevAttachment")

  // Helper to upload files to S3 and get back keys
  const uploadFilesToS3 = async (files) => {
    const uploadedKeys = await Promise.all(
      files.map(async (file) => {
        const attachments = {
          bucket: `${process.env.REACT_APP_BUCKET_NAME}`,
          key: `attachment/${Date.now()}-${file.name}`,
        };

        try {
          const response = await axiosInstance.post(
            `${process.env.REACT_APP_API_FILE_UPLOAD}fileupload`,
            attachments
          );

          await axios.put(response.data.uploadUrl, file, {
            headers: {
              "Content-Type": file.type,
            },
          });

          return response.data.key;
        } catch (error) {
          console.error("Error uploading file:", error);
          return null;
        }
      })
    );

    return uploadedKeys.filter((key) => key !== null);
  };

  // Loop through each key in dynamic values
  for (const key in values) {
    const value = values[key];

    if (Array.isArray(value)) {
      // If value is array → assuming it's a file array
      if (value.length > 0 && value[0] instanceof File) {
        const uploadedKeys = await uploadFilesToS3(value);
        requestData[key] = uploadedKeys;
      } else {
        // If not File instances (e.g. maybe string array like prevAttachment URLs)
        requestData[key] = value;
      }
    } else {
      // Plain text or null
      requestData[key] = value;
    }
  }

  // Special handling: if prevAttachment provided as URLs → clean them
  if (prevAttachment && prevAttachment.length > 0) {
    prevAttachment = prevAttachment.map((url) => {
      const match = url.match(/(attachment\/[^\/]+)/);
      return match ? match[1] : url;
    });
  }


  if(requestData?.resolutionFile){
    requestData.resolutionFile = [...(requestData?.resolutionFile || []), ...(prevAttachment || [])];

  }
    console.log(requestData,"sdgfhsdfjhghjsdf");


  // Final API call
  try {
    const response = await axiosInstance.put("ticket/status", requestData, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error updating ticket status:", error);
    throw error;
  }
};


export const updateTicketStatus = async (ticketId, buttonValue) => {
  try {
    const requestData = {
      status: buttonValue,
      ticketId: ticketId
    };

    const response = await axiosInstance.put("ticket/status", requestData, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const fetchDataBasedOnTktId = async (id) => {
  try {
    const response = await axiosInstance.get(`ticket/${id}`, {
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getLocationInsights = async (cities) => {
  try {
    const response = await axiosInstance.get(`location/list?city=${cities}`, {
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getLocation = async () => {
  try {
    const response = await axiosInstance.get(`location/list`, {
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteAttachment = async (ticketId, attachmentId) => {
  try {
    const response = await axiosInstance.delete(
      `ticket/attachment/${ticketId}`,
      {
        params: {
          attachmentId: attachmentId,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};




export const searchTickets = async (search, page, view, locationName, redirect) => {
  try {
    const response = await axiosInstance.post(
      `ticket/searchList?limit=20&page=${page}`, // page and limit in URL
      {
        search: search,
        view: view,
        locationName: locationName,
        redirect : redirect
      },
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const searchMyTickets = async (search, page, view, locationName, redirect) => {
  try {
  const response = await axiosInstance.post(
  `ticket/myticketsearchlist?limit=20&page=${page}`,
  {
    search: search,
    view: view,
    locationName: locationName,
    redirect : redirect
  }
  );
  return response.data;
  } catch (error) {
  throw error;
  }
  };
  
  export const searchMyTickets2 = async (search, page, view, redirect) => {
    try {
    const response = await axiosInstance.post(
    `ticket/myticketsearchlist?limit=20&page=${page}`,
    {
      search: search,
      view: view,
      redirect : redirect
    }
    );
    return response.data;
    } catch (error) {
    throw error;
    }
    };



export const hierarchyData = async () => {
  try {
    const response = await axiosInstance.get(`assigneegroup/list?page=1`, {
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getEmailSuggestions = async (value) => {
  try {
    const response = await axiosInstance.get(
      `assignee/listemail?email=${value}`,
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const submitUser = async (
  location,
  groupId,
  name,
  email,
  phone,
  level,
  role,
  region,
  password,
) => {
  try {
    const requestBody = {
      location: location,
      groupId: groupId,
      name: name,
      email: email,
      phone: phone,
      level: level,
      role: role,
      region: region,
      password: password,
    };

    const response = await axiosInstance.put(
      "assigneegroup/adduser",
      requestBody,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const removeUser = async (groupId, userId) => {
  try {
    const requestBody = {
      groupId: groupId,
      userId: userId,
    };

    const response = await axiosInstance.put(
      "assigneegroup/removeuser",
      requestBody,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const submitComment = async (ticketId, message, commentFiles,commentType, clientResponseRequired) => {
  try {
    // Validate files array and ensure it's not null/undefined
    if (!commentFiles || !Array.isArray(commentFiles)) {
      commentFiles = [];
    }

    // Filter out invalid files and ensure each file is a valid File object
    const validFiles = commentFiles.filter(file => 
      file instanceof File && file.name && file.type
    );

    // Get pre-signed URLs for valid files
    const fileKeys = await Promise.all(validFiles.map(async (file) => {
      const attachments = {
        bucket: `${process.env.REACT_APP_BUCKET_NAME}`,
        key: `attachment/${Date.now()}-${file.name}`, // Add timestamp to prevent name collisions
      };

      try {
        const response = await axiosInstance.post(
          `${process.env.REACT_APP_API_FILE_UPLOAD}fileupload`,
          attachments
        );

        // Upload file to S3 using pre-signed URL
        await axios.put(response.data.uploadUrl, file, {
          headers: {
            'Content-Type': file.type,
          }
        });

        return response.data.key;
      } catch (uploadError) {
        console.error("Error uploading file:", file.name, uploadError);
        return null;
      }
    }));

    // Filter out any failed uploads
    const successfulFileKeys = fileKeys.filter(key => key !== null);
    console.log(fileKeys,"fileKeys")

    // Send the comment data with file keys
    const commentData = {
      ticketId: ticketId,
      message: message,
      commentFile: successfulFileKeys,
      isExternal : commentType,
      clientResponseRequired : clientResponseRequired
    };

    const response = await axiosInstance.put("ticket/addcomment", commentData, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error submitting comment:", error);
    throw error;
  }
};


export const fetchSLADurations = async () => {
  try {
    const response = await axiosInstance.get(`subcategory/list`, {
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const submitReassign = async (ticketId, message, reassignFile, to) => {
  try {
    // Validate files array and ensure it's not null/undefined
    if (!reassignFile || !Array.isArray(reassignFile)) {
      reassignFile = [];
    }

    // Filter out invalid files and ensure each file is a valid File object
    const validFiles = reassignFile.filter(file => 
      file instanceof File && file.name && file.type
    );

    // Get pre-signed URLs for valid files
    const fileKeys = await Promise.all(validFiles.map(async (file) => {
      const attachments = {
        bucket: `${process.env.REACT_APP_BUCKET_NAME}`,
        key: `attachment/${Date.now()}-${file.name}`,
      };

      try {
        const response = await axiosInstance.post(
          `${process.env.REACT_APP_API_FILE_UPLOAD}fileupload`,
          attachments
        );

        // Upload file to S3 using pre-signed URL
        await axios.put(response.data.uploadUrl, file, {
          headers: {
            'Content-Type': file.type,
          }
        });

        return response.data.key;
      } catch (uploadError) {
        console.error("Error uploading file:", file.name, uploadError);
        return null;
      }
    }));

    // Filter out any failed uploads
    const successfulFileKeys = fileKeys.filter(key => key !== null);

    // Send the reassign data with file keys
    const reassignData = {
      ticketId: ticketId,
      message: message,
      to: to,
      reassignFile: successfulFileKeys
    };

    const response = await axiosInstance.put("ticket/reassign", reassignData, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error reassigning ticket:", error);
    throw error;
  }
};


export const submitIrrelevant = async (ticketId, message, irrelevantFile, to) => {
  try {
    // Validate files array and ensure it's not null/undefined
    if (!irrelevantFile || !Array.isArray(irrelevantFile)) {
      irrelevantFile = [];
    }

    // Filter out invalid files and ensure each file is a valid File object
    const validFiles = irrelevantFile.filter(file => 
      file instanceof File && file.name && file.type
    );

    // Get pre-signed URLs for valid files
    const fileKeys = await Promise.all(validFiles.map(async (file) => {
      const attachments = {
        bucket: `${process.env.REACT_APP_BUCKET_NAME}`,
        key: `attachment/${Date.now()}-${file.name}`,
      };

      try {
        const response = await axiosInstance.post(
          `${process.env.REACT_APP_API_FILE_UPLOAD}fileupload`,
          attachments
        );

        // Upload file to S3 using pre-signed URL
        await axios.put(response.data.uploadUrl, file, {
          headers: {
            'Content-Type': file.type,
          }
        });

        return response.data.key;
      } catch (uploadError) {
        console.error("Error uploading file:", file.name, uploadError);
        return null;
      }
    }));

    // Filter out any failed uploads
    const successfulFileKeys = fileKeys.filter(key => key !== null);

    // Send the reassign data with file keys
    const reassignData = {
      ticketId: ticketId,
      message: message,
      isIrrelevant: to,
      attachment: successfulFileKeys
    };

    const response = await axiosInstance.put("ticket/irrelevant", reassignData, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error reassigning ticket:", error);
    throw error;
  }
};

export const fetchDashboard = async (
  companyName,
  groupType,
  category,
  subCategory,
  ticketType,
  from,
  to,
  locationName,
  city,
  status,
  rating,
  tktStatus,
  region,
  escalationStatus,
  relevance
) => {
  try {
    const response = await axiosInstance.post(
      "ticket/dashboard",
      {
        companyName: companyName,
        groupType: groupType,
        category: category,
        subCategory: subCategory,
        ticketType: ticketType,
        from: from,
        to: to,
        locationName: locationName,
        city: city,
        view: status,
        rating: rating,
        status: tktStatus,
        region: region,
        escalationStatus: escalationStatus,
        relevance: relevance
      },
      
    );
    return response;
  } catch (error) {
    throw error;
  }
};


export const fetchDashboardTickets = async (
  page,
  selectedLocation,
  selectedCompanies,
  selectedDepartments,
  selectedCategories,
  selectedSubCategories,
  selectedTicketTypes,
  selectedCity,
  fromDate,
  toDate,
  status,
  rating,
  tktStatus,
  region,
  escalationStatus,
  relevance
) => {
  try {
    const response = await axiosInstance.post(
      `ticket/dashboardlist?page=${page}&limit=20`, // page and limit in URL
      {
        locationName: selectedLocation,
        companyName: selectedCompanies,
        groupType: selectedDepartments,
        category: selectedCategories,
        subCategory: selectedSubCategories,
        ticketType: selectedTicketTypes,
        city: selectedCity,
        from: fromDate,
        to: toDate,
        view: status,
        rating: rating,
        status: tktStatus,
        region : region,
        escalationStatus: escalationStatus,
        relevance: relevance
      },
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const fetchCityData = async (regions) => {
  try {
    const response = await axiosInstance.get(`location/city?region=${regions}`, {
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const getTicketCounts = async (
  selectedLocation,
  selectedCompanies,
  selectedDepartments,
  selectedCategories,
  selectedSubCategories,
  selectedTicketTypes,
  selectedStatus,
  selectedRating,
  fromDate,
  toDate,
  search
) => {
  try {
    const response = await axiosInstance.post(
      "ticket/kpicount",
      {
        locationName: selectedLocation,
        companyName: selectedCompanies,
        groupType: selectedDepartments,
        category: selectedCategories,
        subCategory: selectedSubCategories,
        ticketType: selectedTicketTypes,
        status: selectedStatus,
        rating: selectedRating,
        from: fromDate,
        to: toDate,
        search: search,
      },
    );
    return response;
  } catch (error) {
    throw error;
  }
};


// export const submitSlaData = async (
//   category,
//   subCategory,
//   defaultDueTime,
//   escalationTime1,
//   escalationTime2,
//   escalationTime3,
//   visibleTo,
//   workflow,
//   groupType,
//   internalOnly,
//   spocOnly,
//   isCentralLocation,
//   tags
// ) => {
//   try {
//     const requestBody = {
//       category: category,
//       subCategory: subCategory,
//       defaultDueTime: defaultDueTime,
//       escalationTime1: escalationTime1,
//       escalationTime2: escalationTime2,
//       escalationTime3: escalationTime3,
//       visibleTo: visibleTo,
//       workflow: workflow,
//       groupType: groupType,
//       internalOnly: internalOnly,
//       spocOnly: spocOnly,
//       isCentralLocation : isCentralLocation,
//       tags:tags
//     };

//     const response = await axiosInstance.post("subcategory", requestBody, {
//       headers: {
//         "Content-Type": "application/json",
//       },
//     });
//     return response.data;
//   } catch (error) {
//     throw error;
//   }
// };

// export const editSla = async (
//   ids,
//   category,
//   subCategory,
//   defaultDueTime,
//   escalationTime1,
//   escalationTime2,
//   escalationTime3,
//   visibleTo,
//   workflow,
//   groupType,
//   internalOnly,
//   spocOnly,
//   isCentralLocation,
// ) => {
//   try {
//     const requestBody = {
//       _id: ids,
//       category: category,
//       subCategory: subCategory,
//       defaultDueTime: defaultDueTime,
//       escalationTime1: escalationTime1,
//       escalationTime2: escalationTime2,
//       escalationTime3: escalationTime3,
//       visibleTo: visibleTo,
//       workflow: workflow,
//       groupType: groupType,
//       internalOnly: internalOnly,
//       spocOnly: spocOnly,
//       isCentralLocation : isCentralLocation
//     };

//     const response = await axiosInstance.put("subcategory", requestBody, {
//       headers: {
//         "Content-Type": "application/json",
//       },
//     });
//     return response.data;
//   } catch (error) {
//     throw error;
//   }
// };




export const submitSlaData = async (data) => {
  try {
    const response = await axiosInstance.post('subcategory', data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    console.log("Submit Response:", response);
    return response?.data; // Ensure you return response.data
  } catch (error) {
    console.error("Submit SLA Error:", error);
    throw error;
  }
};

export const editSla = async (id, data) => {
  try {
    const response = await axiosInstance.put('subcategory', data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    console.log("Edit Response:", response);
    return response?.data; // Ensure you return response.data
  } catch (error) {
    console.error("Edit SLA Error:", error);
    throw error; // Propagate the error
  }
};
export const fetchDepartmentFilter = async (groupType) => {
  try {
    const response = await axiosInstance.get(`common/departmentList?groupType=${groupType}`, {
    });
    return response;
  } catch (error) {
    throw error;
  }
};


export const fetchDepartment = async () => {
  try {
    const response = await axiosInstance.get(`common/departmentList`, {
    });
    return response;
  } catch (error) {
    throw error;
  }
};



export const fetchTicketStatus = async () => {
  try {
    const response = await axiosInstance.get(`common/statusList`, {
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const fetchTicketStatusOptionsData = async (deptType) => {
  try {
    const response = await axiosInstance.get(`common/statusList?type=${deptType}`, {
    });
    return response;
  } catch (error) {
    throw error;
  }
};


export const fetchTicketType = async () => {
  try {
    const response = await axiosInstance.get(`common/ticketTypeList`, {
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const quickFilter = async () => {
  try {
    const response = await axiosInstance.get(`assignee/quickfilter`, {
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const fetchDepartmentForReassign = async () => {
  try {
    const response = await axiosInstance.get(`common/reassignDepartmentList`, {
    });
    return response;
  } catch (error) {
    throw error;
  }
};
export const fetchLocationForRT = async () => {
  try {
    const response = await axiosInstance.get(`location/list?page=1`, {});
    return response;
  } catch (error) {
    throw error;
  }
};
 
export const fetchCategoriesAndSubCategoriesForRaiseticket = async (type) => {
  try {
    const response = await axiosInstance.get(
      `subcategory/categorylist?type=${type}`,
      {}
    );
    return response;
  } catch (error) {
    throw error;
  }
};
 
export const submitRaiseTicket = async (
  attachments,
  subject,
  description,
  locationCode,
  category,
  subCategory,
  ticketType,
  floor,
  companyId,
  companyName,
  channel,
  channelInfo,
  userInfo,
  agentInfo,
  formInfo
) => {
  try {
    const commentData = {
      attachments,
      subject,
      description,
      locationCode,
      category,
      subCategory,
      ticketType,
      floor,
      companyId,
      companyName,
      channel,
      channelInfo,
      userInfo,
      agentInfo,
      formInfo
    };
    
    const response = await axiosInstance.post(
      "ticket/v2",
      commentData,
     
    );
  
    return response.data;
  } catch (error) {
    console.error("Error submitting comment:", error);
    throw error;
  }
}

export const fetchMyTickets = async (page, view, location) => {
  try {
    const response = await axiosInstance.get(
      `ticket/myticketlist?page=${page}&view=${view}&limit=20&locId=${location}`,
      
    );
    return response;
  } catch (error) {
    throw error;
  }
};


export const fetchDataBasedOnTktIdTwo = async (id) => {
  try {
    const response = await axiosInstance.get(`ticket/myticket/${id}`, {
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getMyTicketKpiCount = async () => {
  try {
    const response = await axiosInstance.get(
      "ticket/myticketkpi"
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getAssigneeBaseInfo = async () => {
  try {
    const response = await axiosInstance.get('assignee/baseinfo');
    return response.data;
  } catch (error) {
    throw error;
  }
};